import PopoverDropdownMenu from "../../../Menus/PopoverDropdownMenu";
import DropdownOptionWithIcon from "../../../Menus/DropdownOptionWithIcon";
import GlobalAppLink from "../../../Sidebar/GlobalAppLink";
import DropdownMenuDivider from "../../../Menus/DropdownMenuDivider";
import useCloudPermissions from "../../../../hooks/useCloudPermissions";
import useWorkspacePermissions from "../../../../hooks/useWorkspacePermissions";
import { TreeItem } from "../../types";
import useDeleteItem from "../../../../api/api-hooks/workspaces/sidebar/useDeleteItem";
import useUnpublishCloudApp from "../../../../api/api-hooks/cloudApps/useUnpublishCloudApp";
import { startDeleting } from "./CustomLinkOptions";
import { CloudAppDrawerType } from "../../../Drawers/CloudAppDrawer";

export default function CloudAppOwnerOptions({
  item,
  setAddPage,
  setExistingPageTo,
  setCloudAppDrawerOpened,
  setCloudAppDrawerType,
  setExistingCloudApp,
  setForceUpdateDrawer,
}: {
  item: TreeItem;
  setAddPage: React.Dispatch<React.SetStateAction<string>>;
  setExistingPageTo: React.Dispatch<React.SetStateAction<any>>;
  setCloudAppDrawerOpened: React.Dispatch<React.SetStateAction<boolean>>;
  setCloudAppDrawerType: React.Dispatch<
    React.SetStateAction<CloudAppDrawerType>
  >;
  setExistingCloudApp: React.Dispatch<React.SetStateAction<any>>;
  setForceUpdateDrawer: React.Dispatch<React.SetStateAction<any>>;
}) {
  const { cPermissions } = useCloudPermissions();
  const { wPermissions } = useWorkspacePermissions();
  const { deleteItem } = useDeleteItem();
  const { unpublishCloudApp } = useUnpublishCloudApp();

  const canModify =
    cPermissions.cloud_modify_cloud_app ||
    wPermissions.workspace_modify_cloud_app;

  const canUnpublish =
    cPermissions.cloud_unpublish_cloud_app ||
    wPermissions.workspace_unpublish_cloud_app;

  if (!item?.data) return null;

  const globalAppID =
    item?.data?.Type === "CloudAppOwner" ? item?.data?.GlobalAppID : "";

  return (
    <PopoverDropdownMenu>
      <DropdownOptionWithIcon
        name="Add Page to App"
        icon="mdi mdi-file-table-box-outline"
        onClick={() => setAddPage(item.id)}
        disabled={!canModify}
      />
      <DropdownOptionWithIcon
        name="Add Existing Page to App"
        icon="mdi mdi-share-outline"
        onClick={() => setExistingPageTo(item.data)}
        disabled={!canModify}
      />
      <DropdownOptionWithIcon
        name="Manage App"
        icon="mdi mdi-cog"
        onClick={() => handleEditCloudApp(item)}
        disabled={!canModify}
      />
      <GlobalAppLink
        itemData={item?.data as any}
        setForceUpdateDrawer={setForceUpdateDrawer}
      />
      {globalAppID && (
        <>
          <DropdownMenuDivider />
          <DropdownOptionWithIcon
            name="Unpublish App"
            icon="mdi mdi-delete-outline"
            onClick={() => startDeleting(item, deleteItem, unpublishCloudApp)}
            disabled={!canUnpublish}
          />
        </>
      )}
    </PopoverDropdownMenu>
  );

  function handleEditCloudApp(item: TreeItem) {
    setCloudAppDrawerOpened(true);
    setCloudAppDrawerType("Edit");
    setExistingCloudApp(item.data);
  }
}
